// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { pickUpLocationAddressInfoDisplayStyles } from "@insite/content-library/Widgets/CheckoutReviewAndSubmit/PickUpLocationAddressInfoDisplay";
import { css } from "styled-components";

pickUpLocationAddressInfoDisplayStyles.headingGridItem = {
    width: 12,
    css: css`
        &&& {
            align-items: baseline;
            margin-bottom: 12px;
        }
    `,
};
pickUpLocationAddressInfoDisplayStyles.headingText = {
    variant: "h6",
    css: css`
        margin: 0 24px 0 0;
    `,
};
pickUpLocationAddressInfoDisplayStyles.editLink = {
    typographyProps: {
        size: 12,
        lineHeight: "13px",
    },
};

pickUpLocationAddressInfoDisplayStyles.locationNameText = {
    size: 14,
    lineHeight: "22px",
};
